<!-- ========================= -->
<!-- NEW ARRIVALS SECTION -->
<!-- ========================= -->
<section class="new-arrivals-section pt-100 pb-70">

    <!-- Floating Background Shapes -->
    <div class="arrival-shape shape-one"></div>
    <div class="arrival-shape shape-two"></div>
    <div class="arrival-shape shape-three"></div>

    <div class="container">

        <!-- Section Header -->
        <div class="arrival-section-header">

            <div class="arrival-badge">
                ✨ Fresh Collection
            </div>

            <h2>
                New <span>Arrivals</span>
            </h2>

            <p>
                Explore the latest premium toys added to our magical collection.
            </p>

        </div>

        <!-- Products -->
        <div class="row">

            <div
                class="col-xl-3 col-lg-4 col-md-6"
                *ngFor="let item of newArrivalItems">

                <div class="arrival-product-card">

                    <!-- Product Image -->
                    <div class="arrival-product-image">

                        <a [routerLink]="['/product', item.id]">

                            <img
                                [src]="item.product_image"
                                alt="product"
                                (error)="$any($event.target).src='assets/img/placeholder-product.svg'">

                        </a>

                        <!-- Hover Overlay -->
                        <div class="arrival-overlay">

                            <a
                                [routerLink]="['/product-details', item.id]"
                                class="arrival-btn">
                                View Product
                            </a>

                        </div>

                        <!-- Badge -->
                        <div class="arrival-tag">
                            NEW
                        </div>

                    </div>

                    <!-- Product Content -->
                    <div class="arrival-product-content">

                        <h3>
                            <a [routerLink]="['/product', item.id]">
                                {{ item.product_name }}
                            </a>
                        </h3>

                        <div class="arrival-price">
                            ₹ {{ item.product_price }}
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>